import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const PageTitle = ({ title, copy, children }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
      {copy && <p className="mt-2 text-muted-foreground max-w-2xl">{copy}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Stat = ({ label, value, color = "#4f46e5", testId, hint }) => (
  <div className="card-box p-6 relative overflow-hidden" data-testid={testId}>
    <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full blur-2xl opacity-25" style={{ background: color }} />
    <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
    <div className="mt-3 font-display text-3xl font-extrabold">{value}</div>
    {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
  </div>
);

const S = {
  pending_approval: ["Pending approval", "#f59e0b"], approved: ["Approved", "#10b981"], rejected: ["Rejected", "#ef4444"],
  scheduled: ["Scheduled", "#06b6d4"], published: ["Published", "#7c3aed"], planned: ["Planned", "#4f46e5"],
  draft: ["Draft", "#06b6d4"], paused: ["Paused", "#f59e0b"], active_simulated: ["Active (demo)", "#10b981"],
  paid: ["Paid", "#10b981"], created: ["Created", "#f59e0b"], failed: ["Failed", "#ef4444"], new: ["New", "#db2777"],
  in_progress: ["In progress", "#f59e0b"], resolved: ["Resolved", "#10b981"], active: ["Active", "#10b981"], suspended: ["Suspended", "#ef4444"],
};
export const Badge = ({ s }) => {
  const [l, c] = S[s] || [s, "#64748b"];
  return <span className="inline-flex rounded-full px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider whitespace-nowrap" style={{ background: `${c}1f`, color: c }}>{l}</span>;
};

export const Empty = ({ title, copy, children }) => (
  <div className="card-box p-10 text-center border-dashed">
    <h3 className="font-semibold text-lg">{title}</h3>
    {copy && <p className="mt-2 text-sm text-muted-foreground">{copy}</p>}
    {children && <div className="mt-5 flex justify-center gap-2">{children}</div>}
  </div>
);

export const Locked = ({ feature }) => (
  <div className="card-box p-10 max-w-xl" data-testid="locked-notice">
    <Lock className="h-8 w-8 text-[#7c3aed]" />
    <h2 className="mt-4 text-2xl font-bold">{feature} is not in your plan</h2>
    <p className="mt-2 text-muted-foreground">Upgrade your plan to unlock this feature.</p>
    <Link to="/app/billing" className="btn-brand mt-6" data-testid="locked-upgrade-btn">View plans</Link>
  </div>
);

export const CHANNELS = ["LinkedIn", "Instagram", "Facebook", "X", "Blog", "Email", "Meta Ads", "LinkedIn Ads", "Website"];
export const TYPES = [
  ["social_post", "Social post"], ["email", "Email"], ["ad_copy", "Ad copy"], ["blog", "Blog draft"], ["seo_brief", "SEO brief"], ["webinar", "Webinar / event promo"],
];
export const typeLabel = (t) => (TYPES.find((x) => x[0] === t) || [t, t])[1];
